<app-loading *ngIf="isLoading"></app-loading>

<div class="modal fade" id="modal-setores-producao" tabindex="-1" aria-labelledby="modal-setores-producao" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Setores para Produção - {{ nomeProduto }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="fecharModal()"></button>
            </div>

            <div class="modal-body">
                <!-- Seção de Seleção de Setores (Checkboxes) -->
                <div class="row mb-4">
                    <div class="col-12">
                        <h6 class="fw-bold mb-3">Selecionar Setores</h6>
                        <div class="row" *ngIf="!isTableLoading">
                            <!-- Coluna Esquerda -->
                            <div class="col-md-6">
                                <div class="mb-2" *ngFor="let setor of setoresColunaDireita">
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            [id]="'setor-' + setor.id"
                                            [checked]="isSetorSelecionado(setor.id)"
                                            (change)="selectSetor(setor, $event)"
                                            [disabled]="isLoading || isSetorDesabilitado(setor.id)"
                                            [style.cursor]="isSetorDesabilitado(setor.id) ? 'not-allowed' : 'pointer'">
                                        <label class="form-check-label"
                                               [for]="'setor-' + setor.id"
                                               [class.text-muted]="isSetorDesabilitado(setor.id)"
                                               [style.cursor]="isSetorDesabilitado(setor.id) ? 'not-allowed' : 'pointer'">
                                            {{ setor.nome }}
                                            <small class="text-muted d-block">{{ setor.departamento }}</small>
                                            <small *ngIf="isSetorDesabilitado(setor.id)" class="badge bg-secondary">Já adicionado</small>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <!-- Coluna Direita -->
                            <div class="col-md-6">
                                <div class="mb-2" *ngFor="let setor of setoresColunaEsquerda">
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            [id]="'setor-' + setor.id"
                                            [checked]="isSetorSelecionado(setor.id)"
                                            (change)="selectSetor(setor, $event)"
                                            [disabled]="isLoading || isSetorDesabilitado(setor.id)"
                                            [style.cursor]="isSetorDesabilitado(setor.id) ? 'not-allowed' : 'pointer'">
                                        <label class="form-check-label"
                                               [for]="'setor-' + setor.id"
                                               [class.text-muted]="isSetorDesabilitado(setor.id)"
                                               [style.cursor]="isSetorDesabilitado(setor.id) ? 'not-allowed' : 'pointer'">
                                            {{ setor.nome }}
                                            <small class="text-muted d-block">{{ setor.departamento }}</small>
                                            <small *ngIf="isSetorDesabilitado(setor.id)" class="badge bg-secondary">Já adicionado</small>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="setoresOrdenadosAlfabeticamente.length === 0 && !isLoading" class="text-muted text-center py-3">
                            Nenhum setor disponível
                        </div>
                    </div>
                </div>

                <hr>

                <!-- Tabela de Setores Selecionados com Ordenação -->
                <div class="row">
                    <div class="col-12">
                        <h6 class="fw-bold mb-3">Ordem de Produção</h6>
                        <div class="alert alert-info py-2" *ngIf="setoresOrdenados.length > 0">
                            <small><i class='bx bx-info-circle'></i> Arraste e solte os itens para reordenar a sequência de produção</small>
                        </div>
                        <div class="table-responsive position-relative">
                            <!-- Loading elegante com barra de progresso -->
                            <div class="table-loading-bar" *ngIf="isTableLoading">
                                <div class="progress-line"></div>
                                <div class="loading-message">
                                    <span class="spinner-grow spinner-grow-sm me-2" role="status"></span>
                                    {{ loadingMessage || 'Processando...' }}
                                </div>
                            </div>
                            
                            <table class="table table-striped" [class.table-processing]="isTableLoading">
                                <thead class="table-dark">
                                    <tr>
                                        <th style="width: 80px;">Ordem</th>
                                        <th>Setor</th>
                                        <th>Departamento</th>
                                        <th style="width: 80px;" class="text-center">Ações</th>
                                    </tr>
                                </thead>
                                <tbody cdkDropList (cdkDropListDropped)="onDrop($event)" [cdkDropListDisabled]="isLoading || isTableLoading">
                                    <tr *ngIf="setoresOrdenados.length === 0 && !isTableLoading">
                                        <td colspan="4" class="text-center text-muted py-4">
                                            Nenhum setor selecionado
                                        </td>
                                    </tr>
                                    <!-- Skeleton loader quando carregando -->
                                    <tr *ngIf="isTableLoading && setoresOrdenados.length === 0" class="skeleton-row">
                                        <td colspan="4">
                                            <div class="skeleton-loader">
                                                <div class="skeleton-line skeleton-line-short"></div>
                                                <div class="skeleton-line skeleton-line-medium"></div>
                                                <div class="skeleton-line skeleton-line-long"></div>
                                            </div>
                                        </td>
                                    </tr>
                                    
                                    <tr *ngFor="let item of setoresOrdenados; let i = index" 
                                        cdkDrag 
                                        [cdkDragDisabled]="isLoading || isTableLoading"
                                        class="draggable-row"
                                        [class.row-loading]="isTableLoading">
                                        <td class="fw-bold text-center drag-handle">
                                            <i class='bx bx-grip-vertical drag-icon'></i>
                                            <span class="order-number">{{ item.ordem }}</span>
                                        </td>
                                        <td>{{ item.setor?.nome }}</td>
                                        <td>{{ item.setor?.departamento }}</td>
                                        <td class="text-center">
                                            <button
                                                type="button"
                                                class="btn btn-outline-danger btn-sm"
                                                (click)="removerSetor(i)"
                                                [disabled]="isLoading || isTableLoading"
                                                title="Remover">
                                                <i class='bx bx-trash'></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-success"
                    (click)="salvar()"
                    [disabled]="setoresSelecionados.length === 0 || isLoading">
                    <i class='bx bx-check-circle me-1'></i>Salvar
                </button>
            </div>
        </div>
    </div>
</div>
